import classNames from "classnames"
import * as React from "react"
import { ReactCountryFlag } from "react-country-flag"

export type FlagIconSizes = "xs" | "sm" | "md" | "lg"

interface FlagIconProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  /**
   * The country code of the flag
   * @default undefined
   */
  countryCode?: string | null
  /**
   * The class applied to the flag SVG
   * @default w-4
   */
  className?: string
  /**
   * Indicates the size of the flag
   * @default "xs"
   */
  size?: FlagIconSizes
}

export const FLAG_STYLES_BY_SIZE = {
  xs: { width: "1.5rem", height: "1rem" },
  sm: { width: "1.875rem", height: "1.25rem" },
  md: { width: "2.25rem", height: "1.5rem" },
  lg: { width: "3rem", height: "2rem" },
}

export const FlagIcon = ({ countryCode, size = "xs", className, ...rest }: FlagIconProps) => {
  if (!countryCode) {
    return null
  }

  return (
    <ReactCountryFlag
      countryCode={countryCode}
      svg
      className={classNames("inline-block rounded-sm object-cover shadow", className)}
      style={FLAG_STYLES_BY_SIZE[size]}
      {...rest}
    />
  )
}
